import React, { useCallback } from 'react'
import { useFormContext } from 'react-hook-form'

import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import { Card, CardBody } from 'app/KinerjaShared/components/Card'
import { KinerjaLogOption } from 'app/KinerjaHarian/components/forms/KinerjaLogOption'
import AbsentConfirmationRadio from 'app/KinerjaHarian/components/forms/AbsentConfirmationRadio'
import { CONTENT_FORM_DESCRIPTIONS } from 'app/KinerjaHarian/constants'
import { useKinerjaTipe } from 'app/KinerjaShared/hooks/useKinerjaTipe'
import { useKinerjaHarianRole } from 'app/KinerjaHarian/hooks/useKinerjaHarianRole'

import type {
  KinerjaHarianContent,
  KinerjaHarianFormProps,
} from 'types/kinerja-harian'

type KinerjaLogFormProps = {
  contents: KinerjaHarianContent[]
  editMode?: boolean
}

export function KinerjaLogForm({
  contents,
  editMode = false,
}: KinerjaLogFormProps) {
  const { watch, setValue } = useFormContext<KinerjaHarianFormProps>()
  const { role } = useKinerjaHarianRole()
  const { tipe } = useKinerjaTipe()

  const absentValue = watch('absent')

  const handleAbsentChange = useCallback(
    (checked: boolean) => {
      setValue('absent', checked, {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true,
      })
    },
    [setValue]
  )

  const contentFormDescription = React.useMemo(() => {
    if (tipe === 'GPK') {
      return CONTENT_FORM_DESCRIPTIONS[tipe]
    }
    if (role) {
      return CONTENT_FORM_DESCRIPTIONS[role]
    }
    return undefined
  }, [role, tipe])

  return (
    <Card withBorder>
      <CardBody className="p-6">
        <header className="flex gap-2 mb-2">
          <Icon className="text-secondary-600">check_box_outlined</Icon>
          <div>
            <Text variant="heading-md" as="h2">
              Jenis Kinerja
            </Text>
            <Text className="mt-1" color="subdued">
              {contentFormDescription}
            </Text>
          </div>
        </header>

        {editMode ? (
          <div className="mt-6">
            <AbsentConfirmationRadio
              checked={!!absentValue}
              onChange={handleAbsentChange}
            />
          </div>
        ) : null}

        {editMode && absentValue ? null : (
          <section className="mt-6">
            <Text variant="helper" className="mb-4">
              Pilih jenis Kinerja (Anda dapat memilih lebih dari 1 jenis)
            </Text>

            <div className="-mx-6">
              {contents.map((log) => (
                <KinerjaLogOption
                  key={log.id}
                  id={log.id}
                  label={log.title}
                  descriptionHtml={log.description}
                />
              ))}
            </div>
          </section>
        )}
      </CardBody>
    </Card>
  )
}
